/* istanbul ignore file */

import { getPadraoComRetorno } from 'services/api';
import {
  duckInputTodosAssuntos,
  duckInputSelectOptionsServico,
  duckInputSelectOptionsSexo,
  duckInputSelectOptionsEscolaridade,
  duckInputSelectOptionsProfissao,
  duckInputSelectOptionsAreaAtuacao,
  duckInputSelectOptionsInstituicao,
  duckInputSelectOptionsCargo,
  duckInputSelectOptionsSituacao,
  duckInputRequerimentoCompleto,
  duckInputDadosCadastrais,
} from 'store/ducks/inputs';
import { duckFiltroPesquisaRequerimento, duckFiltroPesquisaRequerimentoContribuinte } from 'store/ducks/formulario';
import { duckTodosStatusListar } from 'store/ducks/status';

export const fetchGetTodosSexos = (listaSexo = []) => dispatch => {
  return new Promise((resolve, reject) => {
    if (listaSexo?.length > 0) resolve(listaSexo);
    else {
      dispatch(getPadraoComRetorno(`Sexo`))
        .then(res => {
          dispatch(duckInputSelectOptionsSexo(res));
          resolve(res);
        })
        .catch(erro => reject(erro));
    }
  });
};

export const fetchGetTodosEscolaridade = (listaEscolaridade = []) => dispatch => {
  return new Promise((resolve, reject) => {
    if (listaEscolaridade?.length > 0) resolve(listaEscolaridade);
    else {
      dispatch(getPadraoComRetorno(`Escolaridade`))
        .then(res => {
          dispatch(duckInputSelectOptionsEscolaridade(res));
          resolve(res);
        })
        .catch(erro => reject(erro));
    }
  });
};

export const fetchGetTodosProfissao = (listaProfissao = []) => dispatch => {
  return new Promise((resolve, reject) => {
    if (listaProfissao?.length > 0) resolve(listaProfissao);
    else {
      dispatch(getPadraoComRetorno(`Profissao`))
        .then(res => {
          dispatch(duckInputSelectOptionsProfissao(res));
          resolve(res);
        })
        .catch(erro => reject(erro));
    }
  });
};

export const fetchGetTodosAreaAtuacao = (listaAreaAtuacao = []) => dispatch => {
  return new Promise((resolve, reject) => {
    if (listaAreaAtuacao.length > 0) resolve(listaAreaAtuacao);
    else {
      dispatch(getPadraoComRetorno(`AreaAtuacao`))
        .then(res => {
          dispatch(duckInputSelectOptionsAreaAtuacao(res));
          resolve(res);
        })
        .catch(erro => reject(erro));
    }
  });
};

export const fetchGetTodosInstituicao = (listaInstituicao = []) => dispatch => {
  return new Promise((resolve, reject) => {
    if (listaInstituicao?.length > 0) resolve(listaInstituicao);
    else {
      dispatch(getPadraoComRetorno(`Instituicao`))
        .then(res => {
          dispatch(duckInputSelectOptionsInstituicao(res));
          resolve(res);
        })
        .catch(erro => reject(erro));
    }
  });
};

export const fetchGetTodasSolicitacao = () => dispatch => {
  return new Promise((resolve, reject) => {
    const url = `Solicitacao/GetServicoAtivo`;
    dispatch(getPadraoComRetorno(url))
      .then(res => {
        dispatch(duckInputSelectOptionsServico(res));
        resolve(res);
      })
      .catch(erro => reject(erro));
  });
};

export const fetchGetTodosAssuntos = (listaAssuntos = []) => dispatch => {
  return new Promise((resolve, reject) => {
    if (listaAssuntos?.length > 0) {
      resolve(listaAssuntos);
    } else {
      dispatch(getPadraoComRetorno(`Assunto`))
        .then(res => {
          dispatch(duckInputTodosAssuntos(res));
          resolve(res);
        })
        .catch(erro => reject(erro));
    }
  });
};

export const fetchGetTodosStatus = (listaStatus = [], finalizarLoading = true) => dispatch => {
  return new Promise((resolve, reject) => {
    if (listaStatus?.length > 0) {
      resolve(listaStatus);
    } else {
      dispatch(getPadraoComRetorno(`Status`, false, finalizarLoading))
        .then(res => {
          dispatch(duckTodosStatusListar(res));
          resolve(res);
        })
        .catch(erro => reject(erro));
    }
  });
};

export const fetchGetTodasSituacoes = (listaSituacoes = []) => dispatch => {
  return new Promise((resolve, reject) => {
    if (listaSituacoes?.length > 0) resolve(listaSituacoes);
    else {
      dispatch(getPadraoComRetorno('Situacao/Situacao'))
        .then(res => {
          dispatch(duckInputSelectOptionsSituacao(res));
          resolve(res);
        })
        .catch(erro => reject(erro));
    }
  });
};

export const fetchGetTodosCargos = (listaCargo = []) => dispatch => {
  return new Promise((resolve, reject) => {
    if (listaCargo?.length > 0) resolve(listaCargo);
    else {
      dispatch(getPadraoComRetorno('Cargo'))
        .then(res => {
          dispatch(duckInputSelectOptionsCargo(res));
          resolve(res);
        })
        .catch(erro => reject(erro));
    }
  });
};

export const fetchSalvarLocalFiltroRequerimento = (filtro, page, pageSize) => dispatch => {
  dispatch(duckFiltroPesquisaRequerimento({ filtro, page, pageSize }));
};

export const fetchSalvarLocalFiltroRequerimentoContribuinte = (filtro, page, pageSize) => dispatch => {
  dispatch(duckFiltroPesquisaRequerimentoContribuinte({ filtro, page, pageSize }));
};

export const fetchSalvarInputsFormularios = inputs => dispatch => {
  dispatch(duckInputRequerimentoCompleto(inputs));
};

export const fetchSalvarInputsDadosCadastrais = inputs => dispatch => {
  dispatch(duckInputDadosCadastrais(inputs));
};

export const fetchAlterarOptionsInputSelectServicoPersonalizado = novoInput => dispatch => {
  dispatch(duckInputSelectOptionsServico(novoInput));
};
